import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrl: './input.component.scss'
})
export class InputComponent {
  @Input() inputStyle: string; // 'default' or 'rounded'
  @Input() inputSize: string; // 'form-control-lg', 'form-control-sm', or empty for default size
  @Input() placeholder: string; // placeholder text for the input field
  @Input() type: string = 'text';
}
